module.exports = __webpack_public_path__ + "static/media/Asset 13.2@3x.4e12a9ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Avatar/Asset 13.2@3x.png
// module id = 2417
// module chunks = 0